"use strict";

var _createForOfIteratorHelper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_state_1 = require("prosemirror-state");

var prosemirror_commands_1 = require("prosemirror-commands");

var Extension_1 = __importDefault(require("../lib/Extension"));

var isUrl_1 = __importDefault(require("../lib/isUrl"));

var isInCode_1 = __importDefault(require("../queries/isInCode"));

var MarkdownPaste = /*#__PURE__*/function (_Extension_1$default) {
  _inherits(MarkdownPaste, _Extension_1$default);

  var _super = _createSuper(MarkdownPaste);

  function MarkdownPaste() {
    _classCallCheck(this, MarkdownPaste);

    return _super.apply(this, arguments);
  }

  _createClass(MarkdownPaste, [{
    key: "name",
    get: function get() {
      return "markdown-paste";
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this = this;

      return [new prosemirror_state_1.Plugin({
        props: {
          handlePaste: function handlePaste(view, event) {
            if (view.props.editable && !view.props.editable(view.state)) {
              return false;
            }

            if (!event.clipboardData) return false;
            var text = event.clipboardData.getData("text/plain");
            var html = event.clipboardData.getData("text/html");
            var state = view.state,
                dispatch = view.dispatch;

            if (isUrl_1.default(text)) {
              if (!state.selection.empty) {
                prosemirror_commands_1.toggleMark(_this.editor.schema.marks.link, {
                  href: text
                })(state, dispatch);
                return true;
              }

              var embeds = _this.editor.props.embeds;

              if (embeds) {
                var _iterator = _createForOfIteratorHelper(embeds),
                    _step;

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var embed = _step.value;
                    var matches = embed.matcher(text);

                    if (matches) {
                      _this.editor.commands.embed({
                        href: text,
                        component: embed.component,
                        matches: matches
                      });

                      return true;
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }

              var _transaction = view.state.tr.insertText(text, state.selection.from, state.selection.to).addMark(state.selection.from, state.selection.to + text.length, state.schema.marks.link.create({
                href: text
              }));

              view.dispatch(_transaction);
              return true;
            }

            if (text.length === 0 || html) return false;
            event.preventDefault();

            if (isInCode_1.default(view.state)) {
              view.dispatch(view.state.tr.insertText(text));
              return true;
            }

            var paste = _this.editor.parser.parse(text);

            var slice = paste.slice(0);
            var transaction = view.state.tr.replaceSelection(slice);
            view.dispatch(transaction);
            return true;
          }
        }
      })];
    }
  }]);

  return MarkdownPaste;
}(Extension_1.default);

exports.default = MarkdownPaste;